const initialMailbox = {
  address: "",
  displayName: ""
};

export default initialMailbox;
